const PDF_FILENAME = "CancerIQ Risk Report.pdf";

function base64ToByteArrays(base64: string): BlobPart[] {
  const byteCharacters = atob(
    base64.replace(/^data:application\/pdf;base64,/, "")
  );
  const byteArrays: Uint8Array[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return byteArrays as BlobPart[];
}

export const downloadPdf = ({ reportPdf }: { reportPdf: string | null }) => {
  if (!reportPdf) {
    alert("No PDF available to download.");
    return;
  }

  const blob = new Blob(base64ToByteArrays(reportPdf), {
    type: "application/pdf",
  });
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = PDF_FILENAME;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};

export function pdfToFile(reportPdf: string | null): File | null {
  if (!reportPdf) return null;
  return new File(base64ToByteArrays(reportPdf), PDF_FILENAME, {
    type: "application/pdf",
  });
}

export function printPdf(reportPdf: string | null): boolean {
  if (!reportPdf) return false;

  const blob = new Blob(base64ToByteArrays(reportPdf), {
    type: "application/pdf",
  });
  const blobUrl = URL.createObjectURL(blob);
  const printWindow = window.open(blobUrl);
  if (printWindow) {
    printWindow.onload = () => printWindow.print();
    return true;
  }
  URL.revokeObjectURL(blobUrl);
  return false;
}
